import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const useRTL = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'he';

  useEffect(() => {
    // Set document direction
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    // Set html lang attribute
    document.documentElement.lang = i18n.language;
  }, [isRTL, i18n.language]);

  return { isRTL, language: i18n.language };
};
